import { type FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import { useUIStore } from '@/store'
import Sidebar from './Sidebar'

const MobileSidebar: FC = () => {
    const { isMobileSidebarOpen, closeMobileSidebar } = useUIStore()
    const location = useLocation()

    // Close sidebar when route changes
    useEffect(() => {
        closeMobileSidebar()
    }, [location.pathname, closeMobileSidebar])

    return (
        <Sheet open={isMobileSidebarOpen} onOpenChange={closeMobileSidebar}>
            <SheetContent side="left" className="p-0 w-64">
                <Sidebar className="relative border-0" />
            </SheetContent>
        </Sheet>
    )
}

export default MobileSidebar
